import * as React from 'react'
import { HomeWidget, Link, 
    PortalContext,
     withPagination} from '@portal/arq-portal-core';

import { makeStyles, Typography } from '@material-ui/core';
import ObtenerComponenteEnlaces from '../hooks/enlaces-hooks';

const useEstilos = makeStyles((theme) => ({

    campanasList: {
        listStyle: 'none',
        padding: '0',
        margin: '0',
    },
    campanasListItem: {
        borderBottom: '1px solid #d6d8d8',
        '& .itemWrapper': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px 0',
            '& .widgetIcon': {
                padding: '0',
                '&:last-of-type': {
                    paddingLeft: '5px',
                },
                '&:hover': {
                    color: '#919191',
                    backgroundColor: 'inherit',
                },
                '&:active': {
                    color: theme.palette.primary.main,
                },
                '& .icon': {
                    fontSize: '1rem',
                },
                '& .MuiTouchRipple-root': {
                    display: 'none'
                }
            }
        },
    },
    campanasContainer: {
        marginTop: '0.75rem'
    },
    titulo: {
        fontSize: '12px',
        flex: 1,
        color: theme.palette.secondary.main,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    pointerLink:{
       cursor: 'pointer'
    }
}));


interface Props {
    titulo?: string
    resultadosPorPagina: any[];
    verMas: string;
    isLoading?:boolean;
    error?:string;
}

const crearUrlEnlace = (enlace: any) => {
    if (!enlace.Url.startsWith("/Aplicacion?")) return `/Aplicacion?aplicacion=${enlace.Tipo}&urlTransaccion=${enlace.Url}`;
    else return enlace.Url
}

const ListaVisorEnlaces = (props: Props): JSX.Element => {
    const {  menuIds } = React.useContext(PortalContext);
    const { resultadosPorPagina, verMas } = props;
    const clases = useEstilos(props);
    const titulo = props?.titulo? props?.titulo : "Enlaces";
    if (resultadosPorPagina && resultadosPorPagina.length) {

        const listItems = resultadosPorPagina.map((item: any, index: number) => {
            let menuItem = menuIds?.get(item?.Url);
            let targetUrl = menuItem?.url;
            if(targetUrl == null || targetUrl == "" || !targetUrl) {targetUrl = (item.Tipo && item.Tipo !== "" && item?.Tipo?.toUpperCase() !== "ENLACE" )? crearUrlEnlace(item) : item.Url}
            return (
                <li className={clases.campanasListItem} key={index}>
                    <div className="itemWrapper">
                    <Typography variant="caption" component={Link} to={targetUrl} classes={{ root: clases.titulo }}>{item.Titulo}</Typography>
                    </div>
                </li>
            )
        }
        );
        return (
            <HomeWidget titulo={titulo} vermas={verMas} error={props.error} isLoading={props.isLoading}>
                <div className={clases.campanasContainer}>
                    <ul className={clases.campanasList}>
                        {listItems}
                    </ul>
                </div>
            </HomeWidget>
        )

    } else {
        return (
            <HomeWidget titulo={titulo} vermas={verMas} error={props.error} isLoading={props.isLoading}>
            </HomeWidget>
        )
    }
}

export const VisorEnlacesPaginado = withPagination(ListaVisorEnlaces, 12);

export const VisorEnlaces = (props: any) => {
    var data: any = undefined;
    var error: any = undefined;
    var verMas: any = undefined;
    var isLoading: boolean = false;
    if (props.data || props.error || props.isLoading) {
        data = props.data;
        error = props.error;
        isLoading = props.isLoading;
        verMas = props.verMas;
    } else {
        const response = ObtenerComponenteEnlaces("VisorEnlaces", props?.IdComponente? props.IdComponente:"");
        if (response) {
            data = response.data?.Salida?.Resultados;
            // error = response.error?.message;
            // verMas = response.data?.Salida?.VerMas;
            // isLoading = response.isValidating;
        }
    }
    return <VisorEnlacesPaginado resultadosPorPagina={data} verMas={verMas} error={error} isLoading={isLoading} titulo={props.titulo} ></VisorEnlacesPaginado>;
}